module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._l((_vm.ArrayVehicles), function(element) {
    return _c('div', {
      attrs: {
        "id": "card-container"
      }
    }, [_c('div', {
      attrs: {
        "id": "info-container"
      }
    }, [_c('div', {
      attrs: {
        "id": "car-info-container"
      }
    }, [_c('div', {
      attrs: {
        "id": "car-info-plate-container"
      }
    }, [_c('h2', {
      attrs: {
        "id": "car-info-plate"
      }
    }, [_vm._v("Placa")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.PlateFormat(element.plate)))])]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "car-info-brand-container"
      }
    }, [_c('h2', {
      staticClass: "car-info",
      attrs: {
        "id": "car-brand-info"
      }
    }, [_vm._v("Marca "), _c('span', [_vm._v(_vm._s(element.model.brand.name))])])])]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "car-info-model-container"
      }
    }, [_c('h2', {
      staticClass: "car-info",
      attrs: {
        "id": "model-info"
      }
    }, [_vm._v("Modelo "), _c('span', [_vm._v(_vm._s(element.model.name))])])])]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "icon-container"
      },
      on: {
        "click": function($event) {
          return _vm.removePlate(element.plate, element.model.name, element.model.brand.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../../assets/img/icons/Icon ionic-md-trash.svg"),
        "alt": ""
      }
    })])])
  }), _vm._v(" "), (!_vm.formVisibility) ? _c('button', {
    attrs: {
      "id": "button-add-vehicles"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('OpenForm')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/img/icons/Icon ionic-ios-add-circle-outline.svg"),
      "alt": "icon-add-vehicles"
    }
  }), _vm._v("\n        Adicionar novo veículo\n    ")]) : _vm._e(), _vm._v(" "), (_vm.modalConfirmVisibility) ? _c('form-modal', {
    attrs: {
      "plate": _vm.plate,
      "brand": _vm.brandName,
      "model": _vm.modelName,
      "type": '1'
    },
    on: {
      "ClickHandlerCancel": _vm.RemoveModal,
      "ClickHandlerContinue": _vm.rmvPlate
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-03e82536!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Adhesion/form-add-vehicles/form-add-vehicles.vue
// module id = 2037
// module chunks = 1